const ctx = {};

const commonHeaders = {
    'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
    'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/126.0.0.0 Safari/537.36'
};

class ApiClient {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.config = {
            headers: { ...commonHeaders }
        };
    }

    async makeRequest(method, url, data, customHeaders = {}) {
        try {
            const headers = { ...this.config.headers, ...customHeaders };
            const fetchOptions = {
                method,
                headers,
            };

            if (method === 'post') {
                fetchOptions.body = new URLSearchParams(data);
            }

            const response = await fetch(`${this.baseUrl}${url}`, fetchOptions);
            return response;
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    async updateContext(response) {
        const cookies = response.headers.get('Set-Cookie');
        Object.assign(ctx, { cookies });
    }
}
const client = new ApiClient('https://rubisuat.volanedev.com/kkportal/');

const loginData = {
    'struts.token.name': 'struts.token',
    'struts.token': '2H6DP0ZAQ3Z4ID168DVFDSUU868LZ8W3',
    usertype: '@CLIENT',
    username: 'BRITISHAIRWAYS',
    password: '1111'
};

const login = async () => {
    const data = Object.keys(loginData).map(key => `${key}=${encodeURIComponent(loginData[key])}`).join('&');
    const response = await client.makeRequest('post', 'validateUserLoginAction.do', data);
    await client.updateContext(response);
};

const getClientDetails = async () => {
    const customHeaders = {
        'Accept-Language': 'en-US,en;q=0.9,zh-CN;q=0.8,zh;q=0.7,fr;q=0.6,ar;q=0.5',
        'Cache-Control': 'no-cache',
        'Connection': 'keep-alive',
        'Cookie': ctx.cookies,
        'DNT': '1',
        'Pragma': 'no-cache',
        'Referer': 'https://rubisuat.volanedev.com/kkportal/loginLink.do',
        'Sec-Fetch-Dest': 'document',
        'Sec-Fetch-Mode': 'navigate',
        'Sec-Fetch-Site': 'same-origin',
        'Sec-Fetch-User': '?1',
        'Upgrade-Insecure-Requests': '1',
        'sec-ch-ua': '"Not/A)Brand";v="8", "Chromium";v="126", "Google Chrome";v="126"',
        'sec-ch-ua-mobile': '?0',
        'sec-ch-ua-platform': 'macOS'
    };
    const response = await client.makeRequest('get', 'getClientDetailsClientAction.do', null, customHeaders);
    const html = response.data;
    console.log(html)
    // const json = await HTMLToJSON(html, true);
    // fs.writeFileSync('./oldSystsemWrap/clientsRes.json', html);
    // const table = json.content.find(node => node.type === 'table' && node.attributes.id === 'example');
    // return table;
};

export default async () => {
    await login();
    console.log(ctx)
    const response = await getClientDetails();

    console.log({response});
};

// main().then(console.log);
